<span
  class="itemWrapper"
  [class.disabled]="disabled()"
  [class.selected]="selected()"
  [id]="'tab-' + icon()">
  <cl-icon
    size="40px"
    aria-hidden="true"
    [icon]="icon()" />
  <span class="linkTitle">
    <ng-content />
  </span>
  @if (newItemsCount()) {
    <span class="newItemsCount">
      {{ newItemsCount() }}
    </span>
  }
</span>
